import { useMemo } from "react";
import type { ApiConfig, GraphInfo } from "../types.ts";
import { useApiQuery } from "./use-api-query.ts";

export const useGraph = (configId?: string) => {
  const { data: config } = useApiQuery<ApiConfig>("/config");

  const defConfigId = useMemo(() => {
    let maybeConfigId: string | undefined;

    if (configId) {
      maybeConfigId = config?.configs?.find((c) => c.id === configId)?.id;
    }

    return maybeConfigId ?? config?.configs?.[0]?.id;
  }, [config, configId]);

  return useApiQuery<GraphInfo>(`/api/app-configs/${defConfigId}/graph`, {
    enabled: !!defConfigId,
  });
};
